<template>
    <footer class="footer gr-container" role="contentinfo" v-bind:class="{ '-menu-opened' : isNavMenuOpenedDelay }">

        <div class="row row-full">
            <div class="gr-2@medium gr-3@large no-gutter-left hide show@large">

                <sound-component v-el:sound></sound-component>

            </div>
            <div class="gr-12 gr-10@medium gr-9@large no-gutter-right _text-right@medium footer-links" v-bind:class="{ '-menu-is-open' : isNavMenuOpenedDelay }">
                <ul>
                    <li v-if="isNavMenuOpenedDelay">
                        <a v-on:click.stop="closeNavPanel()" v-link="{ name: 'privacy' }">Privacy policy</a>
                    </li>
                    <li v-if="isNavMenuOpenedDelay">
                        <a href="https://www.tac.vic.gov.au/about-the-tac/contact-us" rel="nofollow" target="_blank">Contact</a>
                    </li>
                    <li v-if="isNavMenuOpenedDelay" class="hide-on-mobile">
                        <a v-on:click="closeNavPanel()" v-link="{ name: 'accessibility' }">Accessibility</a>
                    </li>
                    <li v-if="isNavMenuOpenedDelay" class="hide-on-mobile">
                        <a v-on:click="closeNavPanel()" v-link="{ name: 'disclaimer' }">Disclaimer</a>
                    </li>
                    <li>
                        Share
                        <a
                        v-el:facebook-share
                        href="#share-on-facebook"
                        title="Share on Facebook"
                        class="facebook-share"
                        rel="nofollow"
                        v-bind:aria-hidden="[ isHotspotPanelOpened ? 'true' : 'false' ]"
                        v-bind:tabindex="[ isHotspotPanelOpened ? '-1' : '0' ]">
                            <i v-if="!isNavMenuOpenedDelay" class="facebook-white@22 size@19"></i>
                            <i v-if="isNavMenuOpenedDelay" class="facebook-black@22 size@19"></i>
                        </a>
                        <a
                        v-el:twitter-share href="#share-on-twitter"
                        title="Share on Twitter"
                        rel="nofollow"
                        class="twitter-share"
                        v-bind:aria-hidden="[ isHotspotPanelOpened ? 'true' : 'false' ]"
                        v-bind:tabindex="[ isHotspotPanelOpened ? '-1' : '0' ]">
                            <i v-if="!isNavMenuOpenedDelay" class="twitter-white@22"></i>
                            <i v-if="isNavMenuOpenedDelay" class="twitter-black@22"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </footer>
</template>

<script>
    import Sound from '../components/Sound'
    import { closeNavMenu, closeNavMenuDelay } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                isNavMenuOpened: state => state.isNavMenuOpened,
                isNavMenuOpenedDelay: state => state.isNavMenuOpenedDelay,
                isHotspotPanelOpened: state => state.isHotspotPanelOpened
            },
            actions: {
                closeNavMenuDelay,
                closeNavMenu
            }
        },

        ready: function () {

            // listen for click on twitter share
            this.$els.twitterShare.addEventListener('click', (event) => {
                event.preventDefault()
                let shareUrl = 'https://twitter.com/share?url=' + this.$root.template.sharing_url + '&text=' + this.$root.template.sharing_twitter + '&hashtags=' + this.$root.template.sharing_hashtag + '&original_referer=' + window.location + ''
                window.open(shareUrl, '_blank')
            }, false)

            // listen for click on facebook share
            this.$els.facebookShare.addEventListener('click', (event) => {
                event.preventDefault()
                let shareUrl = 'https://www.facebook.com/sharer.php?u=' + this.$root.template.sharing_url + ''
                window.open(shareUrl, '_blank')
            }, false)

        },

        methods: {
            closeNavPanel: function () {
                this.closeNavMenu()

                setTimeout(function () {
                    this.closeNavMenuDelay()
                }.bind(this), 50)
            }
        },

        components: {
            'sound-component': Sound
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    .v-loading-first .footer {
        transform: translateY(200%);
    }

    .footer {
        @include headingsStyle();
        transition: transform 0.4s ease-out 0.3s;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        transform: translateY(0);
        overflow: visible;
        padding: 0 $global-viewport-padding-mobile $global-viewport-padding-mobile $global-viewport-padding-mobile;
        color: $white;
        z-index: 6;
        letter-spacing: 2px;
        font-size: 0.75rem;

        &.gr-container {
            overflow: visible;
        }

        @include gridle_state(large) {
            font-size: 0.8rem;
        }

        @include gridle_state(large) {
            letter-spacing: $headings-letter-spacing;
            padding: 0 $global-viewport-padding $global-viewport-padding $global-viewport-padding;
        }

        @include gridle_state(large_max) {
            top: auto;
            bottom: 0;

            &:not(.-menu-opened) {
                top: 100%;
                bottom: auto;
            }

            .footer-links {
                transition: opacity .8s ease-out;

                &:not(.-menu-is-open) {
                    opacity: 0;
                }
            }
        }

        ul, li {
            @include unstyleList();
            display: inline-block;
            margin-top: 0;

            & li:last-child {
                position: relative;
                display: inline-block;

                @include gridle_state(large) {
                    position: relative;
                    display: inline-block;
                }
            }

            & li:not(:last-child):not(:first-child) {
                &:before {
                    content: '|';
                    display: inline-block;
                    padding-right: 0.3rem;
                }

                @include gridle_state(large) {
                    &:before {
                        display: none;
                    }
                }
            }

            & li:not(:first-child) {
                @include gridle_state(large) {
                    margin-left: 1.35rem;
                }
            }
        }

        a {
            color: $white;
            opacity: 0.5;

            &:hover, &:focus {
                opacity: 1;
            }
        }

        &.-menu-opened {
            color: $dark-black;

            a {
                opacity: 1;
                color: $dark-black--fade;

                i {
                    opacity: 0.3;
                }

                &:hover, &:focus {
                    opacity: 1;
                    color: $dark-black;

                    i {
                        opacity: 1;
                    }
                }
            }

            ul, li {
                margin-top: 1.5rem;

                @include gridle_state(large) {
                    margin-top: 0;
                }

                @include gridle_state(xlarge_max) {
                    &.hide-on-mobile {
                        display: none !important;
                    }
                }

                &:last-child {
                    position: absolute;
                    display: block;
                    margin-top: -3.5rem;

                    @include gridle_state(large) {
                        margin-top: 0;
                        position: relative;
                        display: inline-block;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Footer.vue?5562dbcd